<template>
  <div class="inPage">
    <Header @setScroll="setScroll" theme="123"></Header>
    <!-- <div class="banner">
      <div class="word">
        <div class="wordtitle">
          资讯详情
        </div>
        <div class="smalltitle">
          / Information Details
        </div>
      </div>
    </div> -->
    <div class="content">
      <div class="title">{{content.title}}</div>
      <div class="dateinfo">
        <img class="img" src="../../assets/images/time.png">
        <span class="publishTime">{{content.publishTime}}</span>
        <span class="publishTime source" v-if="content.source">{{content.source}}</span>
      </div>
      <div v-html="content.content"></div>
    </div>
    <!--页脚-->
    <Footer class="footer" />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    articleById
  } from '@/api/api'
  export default {
    data() {
      return {
        scroll: 'home',
        id: '',
        content: {},
        baseUrl: serverUrl.baseURL
      }
    },
    components: {
      Header,
      Footer
    },
    created() {
      this.id = this.$route.query.data
      this.getArticleById()
    },
    methods: {
      setScroll(eId) {
        this.scroll = eId
      },
      getArticleById() {
        articleById({
          id: this.id
        }).then(res => {
          this.content = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 400px;
    background: url(../../assets/images/gyzx@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }
  .word {
    width: 1337px;
    margin: 100px auto 0;
  }
  .wordtitle {
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }

  .smalltitle {
    font-size: 16px;
    font-family: Adobe Heiti Std;
    color: #FFFFFF;
    line-height: 46px;
  }
.publishTime {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #767D8A;
    line-height: 22px;
  }

  .img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .dateinfo {
    margin: 28px 0;
    display: flex;
    align-items: center;
  }
  .title {
    font-size: 38px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #36444D;
    line-height: 45px;
  }

  .content {
    width: 1337px;
    margin: 40px auto;
  }
  .inPage{
    padding-top: 120px;
  }
  .dateinfo img{
    width: 20px;
    height: 20px;
  }
  .source{
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/industry/IndustryDetails.vue